import React, { useState } from "react";
import "./Login.css";
import InputBox from "../../components/reusable-input/InputBox";
import Button from "../../components/reusable-button/Button";
import { useNavigate } from "react-router-dom";
import { adminLogin } from "../../apis/authApis";
import { encryptCredential } from "../../utils/encryption";

interface LoginProps {
  setIsAuthenticated: (auth: boolean) => void;
}

const Login: React.FC<LoginProps> = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const encryptedEmail = encryptCredential(email);
    const encryptedPassword = encryptCredential(password);

    const result = await adminLogin({
      email: encryptedEmail,
      password: encryptedPassword,
    });

    if (result.success && result.data?.accessToken) {
      localStorage.setItem("accessToken", result.data.accessToken);
      localStorage.setItem(
        "adminDetail",
        JSON.stringify(result.data.userDetails)
      );
      setIsAuthenticated(true);
      navigate("/app/manage-category");
    } else {
      setError(result.message || "Login failed. Please try again.");
      setIsAuthenticated(false);
    }

    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="logo-section">
        <img
          src="https://www.sos.wa.gov/sites/default/files/2023-03/sos-logo.svg?uid=6853a16092bb8"
          alt="Washington Secretary of State"
          className="logo"
        />
      </div>

      <form className="login-form" onSubmit={handleSubmit}>
        <h3 className="form-title">WSL-LMA Admin Login</h3>

        <InputBox
          label="Email Address"
          required
          placeholder="Enter email address"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          maxLength={120}
        />
        <div className="password-input">
          <InputBox
            label="Password"
            required
            placeholder="Enter password"
            showPasswordToggle
            showPassword={showPassword}
            onTogglePassword={() => setShowPassword((prev) => !prev)}
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            maxLength={120}
          />
        </div>

        {error && <p className="error-text">{error}</p>}
        <Button
          label={loading ? "Logging in..." : "Log In"}
          type="submit"
          loading={loading}
        />
      </form>

      <p className="footer-text">
        Contact your system administrator if you need access
      </p>
    </div>
  );
};

export default Login;
